
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useNotifications } from "@/hooks/useNotifications";

export const useSubscriptionMutations = () => {
  const queryClient = useQueryClient();
  const { success, error: showError } = useNotifications();

  const subscribeMutation = useMutation({
    mutationFn: async (classId: string) => {
      console.log("Subscribing to class:", classId);
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) throw new Error("Usuario no autenticado");

      const { error } = await supabase
        .from("class_subscriptions")
        .insert([{ user_id: user.id, class_id: classId }]);

      if (error) throw error;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["my-classes"] });
      
      success("¡Inscrito con éxito!", {
        description: "Te has inscrito a la clase correctamente."
      });
    },
    onError: (error) => {
      console.error("Error al suscribirse:", error);
      
      showError("No se pudo completar la inscripción. Por favor, intenta de nuevo.");
    },
  });

  const unsubscribeMutation = useMutation({
    mutationFn: async (classId: string) => {
      console.log("Unsubscribing from class:", classId);
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) throw new Error("Usuario no autenticado");

      const { error } = await supabase
        .from("class_subscriptions")
        .delete()
        .eq("user_id", user.id)
        .eq("class_id", classId);

      if (error) throw error;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["my-classes"] });
      
      success("Desinscrito con éxito", {
        description: "Te has desinscrito de la clase correctamente."
      });
    },
    onError: (error) => {
      console.error("Error al desinscribirse:", error);
      
      showError("No se pudo completar la desinscripción. Por favor, intenta de nuevo.");
    },
  });

  return {
    subscribeMutation,
    unsubscribeMutation,
  };
};
